export const CATEGORIES = {
	OTICA: "OTICA",
	MEDICO: "MEDICO",
	LABORATORIO: "LABORATORIO",
	LAB_INDEPENDENTE: "LAB_INDEPENDENTE",
	ESSILOR: "ESSILOR"
};

export const ROLES = {
	CONSULTOR_LABORATORIO: "Consultor Laboratório",
	PROPRIETARIO_OTICA: "Proprietário de Óptica",
	GERENTE_OTICA: "Gerente de Óptica",
	VENDEDOR_OTICA: "Vendedor de Óptica",
	GERENTE_LABORATORIO: "Gerente Laboratório",
	ATENDIMENTO_LABORATORIO: "Atendimento Laboratório",
	GERENTE_LAB_INDEPENDENTE: "Gerente de Lab Independente",
	CONSULTOR_LAB_INDEPENDENTE: "Consultor de Lab Independente"
};

export const IMAGE_PATHS = {
	ESSILOR: "/image/modulos/Mapeamento_PerfisXModulos_Essilor.png",
	LABORATORIO: "/image/modulos/Mapeamento_PerfisXModulos_Laboratorio.png",
	LAB_INDEPENDENTE: "/image/modulos/Mapeamento_PerfisXModulos_LabIndependente.png",
	OTICA: "/image/modulos/Mapeamento_PerfisXModulos_Otica.png"
};

export const isLabIndependente = (papel) => {
	return papel && (
		papel.includes("Independente") ||
		papel === ROLES.GERENTE_LAB_INDEPENDENTE ||
		papel === ROLES.CONSULTOR_LAB_INDEPENDENTE
	);
};